/**
 * standard delay for ui, so the user can read messages
 */
export type IUiDelay = number;

export const UiDelayProvider: {
  provide: string;
  useValue: IUiDelay;
} = {
  provide: 'uiDelay',
  useValue: 8000,
};
